import React from 'react';
import { Grid, Link, Typography } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

import { Child } from '../../../../common/types/child';
import formatter from '../../../../common/helpers/formatter';
import { DecryptedItem } from '../../../../common/types/items';

type Props = {
  child: DecryptedItem<Child>;
};

function ChildEntry({ child: { id, payload } }: Props) {
  const name = payload.name != null && payload.name.trim().length > 0 ? payload.name : 'Kein Name hinterlegt';

  const formattedBirthday = formatter.formatGermanDate(payload.birthday);
  const birthday = formattedBirthday.trim().length > 0 ? formattedBirthday : ' - ';

  return (
    <Grid item xs={12}>
      <Link href={`/children/${id}`} display='flex' flexDirection='row' alignItems='center' gap={2} target='_blank'>
        <OpenInNewIcon fontSize='small' color='primary' />
        <Typography>
          {name} ({birthday})
        </Typography>
      </Link>
    </Grid>
  );
}

export default ChildEntry;
